import * as React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { TR } from 'src/TextRes';
import Footer from '../../components/footer/Footer';
import HeaderLoggedOut from '../../components/headerLoggedOut/HeaderLoggedOut';
import './RegistrationActivation.css';

export default class RegistrationActivation extends React.PureComponent {
    public render() {
        return (
            <>
                <HeaderLoggedOut />
                <Container id="registrationActivationView" className="text-center">
                    <Row>
                        <Col>
                            <h3>{TR.registrationActivation_activate}</h3>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6} className="offset-md-3">
                            {TR.registrationActivation_help}
                        </Col>
                    </Row>
                </Container>
                <Footer />
            </>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/registrationActivation/RegistrationActivation.tsx